export const ROUTE_TUTORIAL = "/tutorial";

export const ROUTE_CONSULTATION = "/consultation";

export const ROUTE_TIMELINE = ROUTE_CONSULTATION + "/timeline";
export const ROUTE_MEDICATION_CREATE = ROUTE_CONSULTATION + "/medicationCreate";
export const ROUTE_MEDICATION = ROUTE_CONSULTATION + "/medicationOverview";
export const ROUTE_MEDICATION_STATUS = ROUTE_MEDICATION + "/status";
export const ROUTE_MEDICATION_SEARCH = ROUTE_MEDICATION + "/search";

export const ROUTE_TARIFICATION = ROUTE_CONSULTATION + "/tarification";
export const ROUTE_TARIFICATION_HELENA = ROUTE_TARIFICATION + "/helena";
export const ROUTE_TARIFICATION_NOM = ROUTE_TARIFICATION + "/nomenclature";
export const ROUTE_TARIFICATION_PATIENT = ROUTE_TARIFICATION + "/patientType";
export const ROUTE_TARIFICATION_EFACT = ROUTE_TARIFICATION + "/eFacteAttest";
export const ROUTE_TARIFICATION_COPAY = ROUTE_TARIFICATION + "/coPayment";
export const ROUTE_TARIFICATION_ATTEST = ROUTE_TARIFICATION + "/attestation";
export const ROUTE_TARIFICATION_PAYMENT = ROUTE_TARIFICATION + "/payment";
export const ROUTE_TARIFICATION_RESUME = ROUTE_TARIFICATION + "/resume";
export const ROUTE_TARIFICATION_FINISH = ROUTE_TARIFICATION + "/finished";
export const ROUTE_TARIFICATION_BACK = ROUTE_TARIFICATION + "/backtostart";
